/*
 * File: NewPatientChart.js
 * Project: mp-mobile-app
 *
 * Created by Jennifer Loecker on 10/03/2019
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Uses the passed in patient store to display top of the chart
 */
import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import CollapseHandler from "./CollapseHandler";
import CollapseCard from "./CollapseCard";

const styles = theme => ({
  topofchart: {
    margin: 0,
    minHeight: theme.spacing(11)
  }
});

const NewPatientChart = ({ classes, patientStore, providerOfficeModel }) => {
  return (
    <div className={classes.topofchart}>
      <CollapseHandler>
        <CollapseCard
          patient={patientStore.patientModel}
          providerModel={providerOfficeModel}
        />
      </CollapseHandler>
    </div>
  );
};

NewPatientChart.propTypes = {
  classes: PropTypes.object.isRequired,
  patientStore: PropTypes.object.isRequired,
  providerOfficeModel: PropTypes.object.isRequired
};

export default withStyles(styles)(NewPatientChart);
